import React, { useEffect, useRef, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon, XIcon, ZoomInIcon } from "lucide-react";
import { pdfPreviews } from "../data/pdfPreviews";
export function SampleCarousel() {
  const [index, setIndex] = useState(0);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const active = pdfPreviews[index];
  const total = pdfPreviews.length;
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    const handleClose = () => triggerRef.current?.focus();
    dialog.addEventListener("close", handleClose);
    return () => dialog.removeEventListener("close", handleClose);
  }, []);
  const openDialog = () => dialogRef.current?.showModal();
  const closeDialog = () => dialogRef.current?.close();
  const go = (delta: number) => setIndex(i => (i + delta + total) % total);
  return <section className="section wash" id="preview" aria-labelledby="preview-heading" data-id="element-107" data-mp="14ndcn0yyjv7l">
      <div className="shell" data-id="element-108" data-mp="1j1dc1q0qo6ha">
        <div className="section-intro" data-id="element-109" data-mp="1j36ib47fwoor">
          <p className="eyebrow" data-id="element-110" data-mp="1j02a7vqut8st">LOOK INSIDE</p>
          <h2 id="preview-heading" data-id="element-111" data-mp="1nzwzxvyw7sca">
            See the planning <span data-id="element-112" data-mp="1a171od0c7mmc">you receive</span>
          </h2>
          <p data-id="element-113" data-mp="1a0f4ixr3dgty">
            Five actual pages from Volume 1: the session agenda, facilitator plan, role cards,
            model dialogue and observation sheet.
          </p>
        </div>
        <div className="sample-layout" data-id="element-114" data-mp="10b421typnaf1">
          <div data-id="element-115" data-mp="109aqc098q006">
            <div className="sample-options" role="group" aria-label="Choose a sample page" data-id="element-116" data-mp="109kl0158cvc7">
              {pdfPreviews.map((page, i) => <button key={page.id} type="button" aria-pressed={i === index} onClick={() => setIndex(i)} data-id="element-117" data-mp="qe91l5ivmzy4" data-mpi={i}>
                  <span data-id="element-118" data-mp="hc9m4hnig3xa">PAGE {page.page}</span>
                  {page.label}
                  <ChevronRightIcon size={16} aria-hidden="true" data-id="element-119" data-mp="mbcmvpwgjnzg" />
                </button>)}
            </div>
            <div className="sample-explanation" aria-live="polite" data-id="element-120" data-mp="2o1tnslrw47tg">
              <h3 data-id="element-121" data-mp="2jabo011lsda2">{active.heading}</h3>
              <p data-id="element-122" data-mp="2j99zouvktuae">{active.text}</p>
            </div>
            <p className="small-note" data-id="element-123" data-mp="2eayqmmd3vnt8">
              These are pages from Sales Conversation Foundations, Volume 1. Click any page to
              enlarge it and read the details.
            </p>
          </div>
          <figure className="sample-figure" data-id="element-124" data-mp="36ze5n8w8m64k">
            <button ref={triggerRef} type="button" onClick={openDialog} aria-haspopup="dialog" aria-label={`Enlarge actual PDF page: ${active.label}`} data-id="element-125" data-mp="36z4c5bbzhgu4">
              <img className="real-pdf-page" src={active.src} alt={active.alt} width={1013} height={1800} loading="lazy" decoding="async" data-id="element-126" data-mp="2szv81a11yd6i" />
              <span className="zoom-label" aria-hidden="true" data-id="element-127" data-mp="1mku7ss4zv8u4">
                <ZoomInIcon size={15} data-id="element-128" data-mp="1hkptn8rk6q72" /> Enlarge page
              </span>
            </button>
            <div className="sample-nav" data-id="element-129" data-mp="3t81nm80hwi7y">
              <button type="button" onClick={() => go(-1)} aria-label="Previous sample page" data-id="element-130" data-mp="3t94be72iu4jn">
                <ChevronLeftIcon size={18} aria-hidden="true" data-id="element-131" data-mp="22thqvzuc62c" />
              </button>
              <span data-id="element-132" data-mp="62tyinaewtck">
                {index + 1} / {total}
              </span>
              <button type="button" onClick={() => go(1)} aria-label="Next sample page" data-id="element-133" data-mp="au27xjbqsepq">
                <ChevronRightIcon size={18} aria-hidden="true" data-id="element-134" data-mp="ft5bt0fzkew4" />
              </button>
            </div>
            <figcaption data-id="element-135" data-mp="ks9hvi7m5wi8">Actual Volume 1 page {active.page} · {active.label}</figcaption>
          </figure>
        </div>
      </div>

      <dialog ref={dialogRef} className="sample-dialog" aria-labelledby="sample-dialog-title" onClick={e => {
      if (e.target === dialogRef.current) closeDialog();
    }} data-id="element-136" data-mp="pr2z9lq0u7no">
        <button type="button" className="dialog-close" onClick={closeDialog} aria-label="Close preview" data-id="element-137" data-mp="2rkabune92b5v">
          <XIcon size={20} aria-hidden="true" data-id="element-138" data-mp="2vkktixbemq0k" />
        </button>
        <h2 id="sample-dialog-title" className="sr-only" data-id="element-139" data-mp="209cvoahq5ja3">
          Volume 1, page {active.page}: {active.label}
        </h2>
        <div className="dialog-body" data-id="element-140" data-mp="1w7zp1y6t5c24">
          <img className="real-pdf-page real-pdf-page--large" src={active.src} alt={active.alt} width={1013} height={1800} decoding="async" data-id="element-141" data-mp="2a8ah34juswov" />
        </div>
        <button type="button" className="dialog-done" onClick={closeDialog} data-id="element-142" data-mp="25aio077h34j3">
          Done
        </button>
      </dialog>
    </section>;
}